import $ from 'jquery';
import product from '@wc-stripe/product';
import cart from '@wc-stripe/cart';
import AbstractMessage from './AbstractMessage';

class ProductMessage extends AbstractMessage {

    initActions() {
        this.actions.addAction('product_updated', this.onProductChange.bind(this));
    }

    showMessageElement() {
        $('.wc-stripe-bnpl-product-message').show();
    }

    onProductChange() {
        if (this.messageElement) {
            this.updateElement();
            if (this.hasPaymentMethodTypes()) {
                this.mountElement();
            } else {
                this.unmountElement();
            }
        }
    }

    getTotalCents() {
        return product.getTotalCents();
    }

    getCurrency() {
        return cart.getCurrency();
    }

    getElementContainer() {
        let el = super.getElementContainer();
        if (!el) {
            el = document.createElement('div');
            el.id = this.selector.replace('#', '');
            const anchor = this.getLocationAnchor();
            if (anchor) {
                anchor.after(el);
            }
        }
        return el;
    }

    /**
     * Returns the DOM element to insert the message container after,
     * based on the product_location setting.
     *
     * @returns {Element|null}
     */
    getLocationAnchor() {
        switch (this.location) {
            case 'above_price':
                const priceEl = document.querySelector('.summary .price') || document.querySelector('.price');
                return priceEl ? priceEl.previousElementSibling : null;
            case 'below_price':
                return document.querySelector('.summary .price') || document.querySelector('.price');
            case 'below_add_to_cart':
                return document.querySelector('button.single_add_to_cart_button') || document.querySelector('form.cart');
            default:
                return document.querySelector('.summary .price') || document.querySelector('.price');
        }
    }
}

export default ProductMessage;